import { Button, Icon, theme } from '@dasa-health/components-react'
import React, { useState } from 'react'
import { SignUpModal } from 'redesign/components/molecules/SignUpModal'
import { MiscOutlineQuestioncircle } from '@dasa-health/icons'
import { ModalDataContainer } from '../style'

export const GenderIdentityModalButton = () => {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <>
            <div>
                <Button borderRadius="pill" onClick={() => setIsOpen(true)} size="compact" type="button" variant="tertiary">
                    <Icon color={theme.colors.black} size={26}>
                        <MiscOutlineQuestioncircle />
                    </Icon>
                </Button>
            </div>
            {isOpen && (
                <ModalDataContainer>
                    <SignUpModal
                        setShowModal={() => {
                            setIsOpen(v => !v)
                        }}
                        showModal={isOpen}
                        title="Por que queremos saber sobre sua identidade de gênero?"
                    >
                        <p>
                            A identidade de gênero é a forma pela qual a pessoa se expressa, o gênero com o qual ela se identifica.
                            Pergunta importante para um serviço de atendimento e saúde inclusivo.
                        </p>
                    </SignUpModal>
                </ModalDataContainer>
            )}
        </>
    )
}
